import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class WhitepaperspageService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  whitePapersData: any;
  whitePaperArticleData: any;

  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();
  private whiteaperDataSubject$ = new BehaviorSubject<any>(null);
  public whiteaperData$ = this.whiteaperDataSubject$.asObservable();
  private whiteaperArticleDataSubject$ = new BehaviorSubject<any>(null);
  public whiteaperArticleData$ =
    this.whiteaperArticleDataSubject$.asObservable();

  getnewsroomData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.whitepapersAndReports,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.whitePapersData = mod[0].fields;
        const getStarted = this.whitePapersData.gettingStartedPanel.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
        const whiteaperData = this.whitePapersData;
        if (whiteaperData) {
          this.whiteaperDataSubject$.next(whiteaperData);
        }
      });
  }
  getAllWhitepaperArticles(): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          content_type: PageId.whitepapersAndReportsArticle,
          include: 10,
          limit: 300
        })
      )
      .then(res => res.items);
  }
  getWhitepaperArticleByID(query: any): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.whitepapersAndReportsArticle,
          'fields.blogId': query,
        })
      )
      .then(res => res.items);
  }

  getWhitepaperArticleData(id: string) {
    this.getWhitepaperArticleByID(id).then(data => {
      this.whitePaperArticleData = data[0].fields;
      if (this.whitePaperArticleData) {
        this.whiteaperArticleDataSubject$.next(this.whitePaperArticleData);
      }
    });
  }
}
